import { withLeaflet } from 'react-leaflet';
import * as Leaflet from 'leaflet';
import * as React from 'react';
import * as VehiclesModule from 'Modules/VehiclesModule';
import { layerFactory, CanvasMarkerData } from './leaflet.canvas-markers';
import { RootState } from "Redux/Reducers/_RootReducer";
import { connect } from "react-redux";

const L = layerFactory(Leaflet);
const DATA_FRAMES_LIMIT = 3000

interface CustomCanvasMarkersP {
    onMarkerClick?: (event: any, dataframe: VehiclesModule.Types.CarDataframeDto) => void;
    mapRef: L.Map;
    latestDataframes: Array<VehiclesModule.Types.CarDataframeDto>;
    componentMapRef: any;
    zoom: number;
    minZoomToShowDirectionsOnTrack: number;
    leaflet?: {
        map: L.Map;
    };
}
interface CustomCanvasMarkersS {
    //
}
class CustomCanvasMarkers extends React.Component<CustomCanvasMarkersP, CustomCanvasMarkersS> {
    private ciLayer: any;
    constructor(props: CustomCanvasMarkersP) {
        super(props);
        this.generateCanvas = this.generateCanvas.bind(this);
        this.ciLayer = L.canvasIconLayer({}).addTo(this.props.mapRef);
        this.generateCanvas();
    }
    public generateCanvas() {
        try {
            const markers = [];
            this.ciLayer.clearLayers();
            const shouldShowDirectionsOnTrack = this.props.latestDataframes.length <= DATA_FRAMES_LIMIT
                && this.props.zoom > this.props.minZoomToShowDirectionsOnTrack
            if (this.props.latestDataframes.length > 0) {
                this.props.latestDataframes.forEach((dataframe, idx) => {
                    const position: L.LatLngExpression = [dataframe.latitude, dataframe.longitude];
                    const isLast = idx === this.props.latestDataframes.length - 1
                    const isFirst = idx === 0
                    if (!shouldShowDirectionsOnTrack && !isFirst && !isLast) {
                        return
                    }
                    const icon = L.icon(this.getRideIconForCanvas(idx, isLast, dataframe.heading));
                    const marker = L.marker(dataframe, position, { icon });
                    markers.push(marker);
                });
                if (this.props.onMarkerClick) {
                    this.ciLayer.addOnClickListener((event, markersData: Array<CanvasMarkerData>) => {
                        if (markersData.length > 0) {
                            this.props.onMarkerClick(event, markersData[0].data.latestDataframe);
                        } else {
                            this.props.onMarkerClick(event, null);
                        }
                    });
                }
                this.ciLayer.addLayers(markers);
            }
        } catch (err) {
            console.warn(err);
        }
    }
    public componentDidUpdate() {
        this.generateCanvas();
    }
    public componentWillUnmount() {
        this.ciLayer._context.clearRect(0, 0, this.ciLayer._canvas.width, this.ciLayer._canvas.height);
        this.ciLayer.clearLayers();
    }
    private getRideIconForCanvas(idx: number, last: boolean, heading: number): L.IconOptions {
        if (last) {
            return {
                iconUrl: '/images/icons/ride_end.svg',
                iconSize: [25, 25],
                iconAnchor: [12, 24],
                className: `rotate_0`
            };
        } else if (idx === 0) {
            return {
                iconUrl: '/images/icons/ride_start.svg',
                iconSize: [25, 25],
                iconAnchor: [12, 24],
                className: `rotate_0`
            };
        } else {
            return {
                iconUrl: '/images/icons/canvas_direction_arr.svg',
                iconSize: [10, 12],
                iconAnchor: [5, 11],
                className: `rotate_${heading}`
            };
        }
    }
    public render() {
        return <div className="CustomCanvasMarkers" />;
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        zoom: state.mapStore.smallMap.zoom,
        minZoomToShowDirectionsOnTrack: state.mapStore.minZoomToShowDirectionsOnTrack
    }
};

export default withLeaflet(connect(mapStateToProps)(CustomCanvasMarkers))



// WEBPACK FOOTER //
// ./src/components/Map/MapHelpers/CanvasMarkersLayer/CustomCanvasMarkers.tsx